import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';

import { getStartEndTimesBasedOnBookingStatus } from '../../../util/bookingHelpers';

import './Day.css';

export default class Day extends PureComponent {
    static propTypes = {
        day: PropTypes.object.isRequired,
        start: PropTypes.object.isRequired,
        end: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.day);
    }

    render() {
        const {
            day,
            start,
            end
        } = this.props;

        const bookingDayCssClass = day.isBetween(start, end, `d`, `[]`) ? `booking-day` : ``;
        const bookingStartCssClass = day.isSame(start, `d`) ? `booking-start-day` : ``;
        const bookingEndCssClass = day.isSame(end, `d`) ? `booking-end-day` : ``;

        return (
            <div className="day-container" onClick={this.handleClick}>
                <div className={`day ${bookingDayCssClass} ${bookingStartCssClass} ${bookingEndCssClass}`}>
                    {day.format(`D`)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/Day.jsx